function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-a0e87de4\",\"scoped\":true,\"hasInlineConfig\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./VueBootstrapTypeahead.vue")
}
var normalizeComponent = require("!../../../vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]],\"plugins\":[\"transform-object-rest-spread\",[\"transform-runtime\",{\"polyfill\":false,\"helpers\":false}]]}!../../../vue-loader/lib/selector?type=script&index=0!./VueBootstrapTypeahead.vue")
/* template */
var __vue_template__ = require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a0e87de4\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../vue-loader/lib/selector?type=template&index=0!./VueBootstrapTypeahead.vue")
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0e87de4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue
// module id = 674
// module chunks = 0 1